import{m as e}from"./chunk-HBP5N4FR.js";e();var n=(t=>(t.NOT_INITIALIZED="not_initialized",t.PENDING="pending",t.COMPLETED="completed",t))(n||{}),c={current:null,status:"not_initialized"};export{n as a,c as b};
//# sourceMappingURL=chunk-3SGZP5CP.js.map
